function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 50.8 50.8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M25.294 44.98 42.07 5.82H12.7l5.822 9.79-9.79 9.26h15.346",
    style: {
      opacity: 1,
      fill: "none",
      fillRule: "evenodd",
      stroke: "#000000",
      strokeWidth: 3.17501,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0
    }
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWise);
export default __webpack_public_path__ + "static/media/wise.5a760237.svg";
export { ForwardRef as ReactComponent };